import React, {useMemo} from "react";
import {Typography,} from "@material-ui/core";
import {useProfile} from "../../../hooks/useProfile";
import {AdminFundingPage} from "./AdminFundingPage";
import {ClientFundingPage} from "./ClientFundingPage";

export const FundingPage = () => {
  const {profile} = useProfile()

  const title = useMemo(() => {
    return "Account Balances"
  }, [])

  return (
    <>
      <Typography variant="h4">{title}</Typography>
      {profile?.role === 'admin' && (<AdminFundingPage />)}
      {profile?.role === 'client' && (<ClientFundingPage profile={profile} />)}
    </>
  );
};
